<nav class="navbar">
  @if (showLogo) {
    <a
      class="logo"
      id="logo"
      [class.disabled]="isNavbarDisabled()"
      [routerLink]="logoRoute()"
      [style.pointer-events]="navbarPointerEvents()"
      [style.opacity]="navbarOpacity()">
      <span>
        <img
          class="logo__image"
          [src]="
            isArabic() ? 'assets/images/logo-ar.svg' : 'assets/images/logo.svg'
          "
          alt="Cadaa" />
      </span>
    </a>
  }

  <!-- <div class="actions">
    <ul class="actions__list">
      <li class="actions__item">
        <img src="assets/icons/notification.svg" alt="notification" />
      </li>
    </ul>
  </div> -->

  <div
    class="change-language"
    [class.disabled]="isNavbarDisabled()"
    [style.pointer-events]="navbarPointerEvents()"
    [style.opacity]="navbarOpacity()"
    (click)="openChangeLanguage()">
    <img
      src="assets/images/settings/change-language.svg"
      alt="change language" />
    <span>{{ 'settings_screen_change_language_row_label' | translate }}</span>
  </div>
</nav>

<app-change-language
  [openChangeLanguageDialog]="showChnageLanguageDialog()"
  (closeDialog)="onCloseChangeLanguageDialog()" />
